import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useContext, useRef } from 'react';
import { useCookies } from 'react-cookie';
import { connect } from 'react-redux';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { compose } from 'redux';
import { PATH, APPLICATION_FINDER_URL, QUERY_KEY, STORE_LINK_CAMPAIGN_COOKIE_OPTIONS, WIZARD_URL, PROVE_CHANNEL_PREQUALIFY, Button, P, Span, reportError, apiErrorToErrorMessage, isPresent, parseQuery, AnalyticsContext, } from 'shared';
import { useLazyGetConsumerApplicationsV2PrequalificationsNewQuery } from 'consumer-applications-v2-api';
import { useSessionStorage } from 'hooks';
import { toastError } from 'utils';
import * as actions from '../actions';
import { PracticeSearchInput } from '../components';
import { selectors } from '../reducer';
function Home({ clearPractice, practice, clearPersonalInfo, personalInfo, }) {
    // Hooks
    const { analytics } = useContext(AnalyticsContext);
    const history = useHistory();
    const { search } = useLocation();
    const query = parseQuery(search);
    const [, setCookie] = useCookies(['storeLinkCampaign']);
    const { resetValue: resetIsOTA } = useSessionStorage('isOTA');
    const queryParams = parseQuery(location.search);
    const storeLinkCampaign = useRef(queryParams[QUERY_KEY.STORE_LINK_CAMPAIGN]);
    const otlRef = useRef(query[QUERY_KEY.OTL]);
    const [getConsumerApplicationsV2PrequalificationsNew, { isLoading: isLoadingPrequalNew },] = useLazyGetConsumerApplicationsV2PrequalificationsNewQuery();
    const handleClick = async (url) => {
        analytics?.track('ClickPrequalifyButton', {});
        if (PATH.PROVE?.BASE) {
            if (PROVE_CHANNEL_PREQUALIFY) {
                const res = await getConsumerApplicationsV2PrequalificationsNew({
                    locationId: practice?.locationId,
                    termsLanguage: 'en',
                });
                if (res.data) {
                    const { proveOptOut } = res.data;
                    if (!proveOptOut) {
                        const provePath = `${PATH.CREDIT_PORTAL}${PATH.PROVE?.BASE}`;
                        history.push(provePath);
                    }
                    else {
                        history.push(url);
                    }
                }
            }
            else {
                history.push(url); // Old Path
            }
        }
        else {
            history.push(url);
        }
    };
    useEffect(() => {
        resetIsOTA();
        const initialError = query[QUERY_KEY.ERROR];
        if (initialError) {
            const errMsg = apiErrorToErrorMessage(initialError);
            reportError('flashError', {
                componentName: 'Home',
                funcName: 'useEffect',
                errType: 'query',
                errURL: window.location.pathname,
                errMsg: errMsg,
            });
            toastError(errMsg);
        }
        if (isPresent(practice))
            clearPractice();
        if (isPresent(personalInfo))
            clearPersonalInfo();
    }, []);
    useEffect(() => {
        if (storeLinkCampaign.current && otlRef.current) {
            setCookie('storeLinkCampaign', {
                campaignId: storeLinkCampaign.current,
                storeId: 'all',
                otl: otlRef.current,
            }, STORE_LINK_CAMPAIGN_COOKIE_OPTIONS);
        }
    }, [storeLinkCampaign.current, otlRef.current, setCookie]);
    return (_jsx(_Fragment, { children: _jsx("div", { className: "home-content", children: _jsxs("div", { className: "home-container", children: [_jsxs("div", { className: "home-left", children: [_jsx(P, { className: "practice", variant: "headline-large", children: "Select Your Practice" }), _jsx("div", { className: "simple-form", children: _jsx(PracticeSearchInput, { searchPromptText: "CONTINUE WITH PRACTICE" }) }), _jsx(Link, { to: APPLICATION_FINDER_URL, children: _jsx(Span, { variant: "title-small", children: "Application already started?" }) })] }), _jsx("div", { className: "separator", children: _jsx(Span, { className: "or", children: "OR" }) }), _jsxs("div", { className: "home-right", children: [_jsx(P, { className: "practice", variant: "headline-large", children: "Haven't chosen a doctor yet?" }), _jsx(Button, { type: "button", onClick: () => handleClick(WIZARD_URL), className: "button-warn-outline qualify", submitting: isLoadingPrequalNew, children: "PRE-QUALIFY" })] })] }) }) }));
}
function mapStateToProps(state) {
    return {
        practice: selectors.practice(state),
        personalInfo: selectors.personalInfo(state),
    };
}
const mapDispatchToProps = {
    clearPractice: actions.clearPractice,
    clearPersonalInfo: actions.clearPersonalInfo,
};
export default compose(connect(mapStateToProps, mapDispatchToProps))(Home);
